/**
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([], () => {

	const MAX_CALL_COUNT = 3;

	/**
	 * Class to keep prompts state. The owner of this class is a widget since prompt values are cached at widget level.
	 */
	class PromptsState {

		constructor() {
			this._promptsState = {};
		}

		destroy() {
			this._promptsState = null;
		}

		reset() {
			this._promptsState = {};
		}

		/**
		 * @param {PromptSpec[]} specList Array of the prompt specs
		 */
		updatePromptsState(specList) {
			specList && specList.forEach(spec => {
				// Increase the call count for each prompt
				const state = this._promptsState[spec.name];
				if (!state) {
					this._promptsState[spec.name] = 0;
				}
				this._promptsState[spec.name]++;
			});
		}

		hasInProgressPrompts() {
			return Object.keys(this._promptsState).length > 0;
		}

		hasInValidState(specList) {
			// Is invalid if specList is undefined or at least one prompt tries to resolve the prompt values more than MAX_CALL_COUNT
			return !specList || (specList.find(spec => {
				return this._promptsState[spec.name] && this._promptsState[spec.name] >= MAX_CALL_COUNT;
			}) !== undefined);
		}

	}

	return PromptsState;

});